<div *ngIf="form" [formGroup]="form">

    <label for="name">Name</label>
    <input type="text" class="form-control" formControlName="name" id="name">

    <!--Uploading an image-->
    <label class="btn btn-primary btn-block space" for="image">
        <i class="fas mr-2" [ngClass]="{
        'fa-file-image': !uploaded,
        'fa-check-circle': uploaded
        }"></i>{{uploaded ? 'Uploaded' : 'Upload image'}}
    </label>
    <!--Uploading an image trigger-->
    <input (change)="uploadImage($event.target.files)" accept=".png,.jpg" class="d-none" id="image" type="file" />
    <div *ngIf="error" class="error mt-2 mb-4">{{error}}</div>

    <label for="type">Type</label>
    <select class="form-control" formControlName="type" name="type" id="type">
        <option value="" selected></option>
        <!--Fetching all types of an item (Food, Beverages, Useful)-->
        <option *ngFor="let type of itemService.types" [value]="type.toLocaleLowerCase()">{{type}}</option>
    </select>

    <!--Toggle advanced options-->
    <button *ngIf="!collapsed" (click)="collapsed = true" class="btn btn-light my-5">Advanced settings</button>
    <br />

    <!--Advanced options-->
    <ng-container *ngIf="collapsed">

        <div class="d-flex mb-5">
            <p class="m-0 d-flex flex-column justify-content-center">hide: ‘brought by’, ‘for how many persons’ and 'person icon’</p>
            <ng-switchery (click)="toggleItem(this.id, detailsV)" class="ml-4" formControlName="detailsVisibility" color="switchery-success"></ng-switchery>
        </div>

        <label for="abstract">Abstract</label>
        <input type="text" class="form-control" formControlName="abstract" id="abstract">

        <label for="description">Description</label>
        <textarea class="form-control" formControlName="description" id="description" rows="5"></textarea>

        <label for="weight">Weight</label>
        <input type="number" class="form-control" formControlName="weight" id="weight">

        <label for="rating">Rating</label>
        <input type="number" class="form-control" formControlName="rating" id="rating">

        <label for="reviews">Reviews</label>
        <input type="text" class="form-control" formControlName="reviews" id="reviews">

        <label for="price">Price</label>
        <input type="number" class="form-control" formControlName="price" id="price">

        <label for="currency">Currency</label>
        <input type="text" class="form-control" formControlName="currency" id="currency">

        <label for="link">Link</label>
        <input type="text" class="form-control" formControlName="link" id="link">

        <label for="partner">Partner</label>
        <input type="text" class="form-control" formControlName="partner" id="partner">

        <label for="partnerId">Partner ID</label>
        <input type="text" class="form-control" formControlName="partnerId" id="partnerId">
    </ng-container>
    <!--Submitting the form-->
    <button (click)="submitForm()" class="btn btn-primary btn-block mt-5" [disabled]="form.invalid">{{id ? 'Save' : 'Add'}} item</button>
    <!--Cancellation-->
    <button (click)="ngOnInit()" class="btn btn-light btn-block mt-3">Cancel</button>

</div>
